import client from "@/api";

export const getEntity = async (entity) => {
  return await client.get(`/entities/${entity}`);
};

export const replicateBullhornEntity = async () => {
  return await client.get("/notes/persist-call-time");
};

export const generateFile = async (entity) => {
  const url = entity ? `entities/${entity}/generate-file` : "/notes/generate-call-time-file";

  return await client.get(url);
};

export const getFileInfo = async (entity) => {
  return await client.get(`entities/${entity}/file-info`);
};
